import { useMemo, useRef, useEffect } from "react";
import { TextField, InputAdornment } from "@mui/material";
import PropTypes from 'prop-types';
import SearchIcon from "@mui/icons-material/Search";
import CloseSharp from "@mui/icons-material/CloseSharp";
import { debounce } from "lodash";
import styled from "styled-components";

const CloseButton = styled.button`
 border: none;
 background: transparent;
 cursor: pointer;
 padding: 0;
 display: flex;
 align-items: center;
`;
const CustomSearchTextField = ({ column, handleSearch }) => {
  const inputRef = useRef(null);
  const searchText = column.getFilterValue();
  const debouncedFilter = useMemo(
    () =>
      debounce((value) => {
        column.setFilterValue(value || undefined);
        handleSearch?.(value, column.id);
      }, 600),
    [column, handleSearch]
  );

  useEffect(() => {
    const initialValue = column.getFilterValue();
    if (inputRef.current && typeof initialValue === "string") {
      inputRef.current.value = initialValue;
    }
  }, []);

  const handleChange = (e) => {
    debouncedFilter(e.target.value);
  };

  const handleClear = () => {
    debouncedFilter.cancel();
    if (inputRef.current) {
      inputRef.current.value = "";
    }
    column.setFilterValue(undefined);
    handleSearch("", column.id);
  };
  return (
    <TextField
      inputRef={inputRef}
      defaultValue=""
      onChange={handleChange}
      onKeyDown={(e) => {
        e.stopPropagation();
      }}
      variant="outlined"
      size="small"
      fullWidth
      slotProps={{
        input: {
         startAdornment: (
          <InputAdornment position="start">
            {(searchText === null || searchText === "" || searchText === undefined ) &&
            <SearchIcon fontSize="small" />}
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            {(searchText !== null && searchText !== "" && searchText !== undefined ) && 
            <CloseButton onClick={handleClear}>
              <CloseSharp fontSize="small" />
            </CloseButton>}
          </InputAdornment>
        ),
        }
      }}
      sx={{
        mt: 1,
        "& .MuiInputBase-input": {
          fontSize: "12px",
          fontFamily: "Nunito Sans",
        },
      }}
    />
  );
};

CustomSearchTextField.propTypes = {
  column: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    getFilterValue: PropTypes.func,
    setFilterValue: PropTypes.func,
  }).isRequired,
  handleSearch: PropTypes.func.isRequired,
};
export default CustomSearchTextField;